(ns com.theplantscape.plant-web.pages.polyculture
  (:require
   [reagent.core :as r]
   [cljs.core.async :refer [<! go]]
   [clojure.walk :as walk]
   [reitit.frontend.easy :as rfe]
   [com.theplantscape.calculate.ensemble
    :refer [extend-line
            generate-radius
            line-circle-intersection
            snap-closest-radius]]
   [com.theplantscape.local-store.ensemble :refer [insert-plant-data rm-entity get-plant-entity-id-from-uuid]]
   ;[com.theplantscape.local-store.plants-db :refer [insert-plant-data]]
   [com.theplantscape.local-store.polyculture-db
    :refer [fetch-polyculture-plants
            fetch-polyculture-plants-stats
            fetch-polyculture-entity-id-from-uuid

            update-polyculture-settings
            insert-polyculture-data
            remove-polycultures]]
   [com.theplantscape.plant-web.api.polycultures
    :refer [create-new-polyculture
            create-new-revision-polyculture
            delete-polyculture
            fetch-polyculture
            fetch-polycultures]]
   [com.theplantscape.plant-web.components.plants.link :refer [plant-link]]
   [com.theplantscape.plant-web.components.search :refer [ui-plant-search search-selected-plant]]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async]]
   [com.theplantscape.plant-web.components.tailwind.icons.gear
    :refer [icon-gears]]
   [com.theplantscape.plant-web.pages.polyculture.forms :refer [polyculture-settings-form]]
   [com.theplantscape.plant-web.draw.actions :refer [plant-info-modal]]
   [com.theplantscape.plant-web.draw.db :refer [register-query]]
   [com.theplantscape.plant-web.draw.formatting :refer [plant-name]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state
            build-api-url
            reset-editing
            set-mode
            site-data
            svg-transform
            update-zoom]]
   ;[com.theplantscape.plant-web.draw.ui-form :as form]
   [com.theplantscape.plant-web.pages.diagram.view :refer [insert-plant-mode]]
   [com.theplantscape.plant-web.draw.ui-plant-info :refer [ui-plant-info]]
   [com.theplantscape.plant-web.pages.polyculture.events :refer [action]]
   [com.theplantscape.svg-generation.ensemble :as svg]
   [com.theplantscape.web-ui.ensemble :as u]
   [com.theplantscape.web-ui.svg.canvas :as svgh]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [simple-list picture grid-layout-one]]
   [com.theplantscape.plant-web.components.tailwind.forms.polycultures :refer [ui-form-create-polyculture]]))

(defn ui-circles [center radius-seq]
  (->> radius-seq
       (mapv (fn [num] [:circle {:cx center :cy center :r (str num)
                                 :style {:fill "none"
                                         :stroke-width "0.5"
                                         :stroke "#ff0000"}}]))
       (into [:g])))

(defn ui-svg-polyculture-preview
  ([{:keys [width height view-box] :as size} distance number]
   (ui-svg-polyculture-preview size (generate-radius distance number)))
  ([{:keys [width height view-box] :as size} radius-seq]
   (let [center 0 ;(/ width 2)
         radius (snap-closest-radius
                 [center center]
                 (-> @app-state :pointer :current :pos) radius-seq)]
     [:g#preview-translated {:style {:pointer-events "none"}}
      [ui-circles center radius-seq]
      ;; This should be improved we should use a ray not an extended line
      ;; works for now as a demo
      [svg/point :preview-point (-> @app-state :pointer :current :pos) "3"]
      [svg/point :preview-point
       (first (line-circle-intersection
               [center center]
               (second (extend-line [center center] (-> @app-state :pointer :current :pos) 200))
               [center center] radius)) "3"]
      #_[svg/point :preview-point2 (-> @app-state :pointer :current :pos) "2"]])))

#_(defn plant-search-selection
    [#_tmp-atom {:keys [id plant-id type revision] :as p}]
    (set-mode :insert)
    (swap! app-state assoc-in [:current :plant] p))

(defn polyculture-click-event [circles action-type pos]
  ;;(set-mode :select)
  (action circles action-type pos)
  #_(swap! app-state assoc-in [:current :mode] :move)
  #_(case (-> @app-state :current :mode)
      :insert (add-plant->polyculture circles pos)))

(defn polyculture->fmt-db
  [polyculture plants]
  (merge
   (select-keys polyculture [:polyculture/title :polyculture/description])
   {:polyculture/public (boolean (polyculture :polyculture/public))}
   {:polyculture/plants
    (mapv (fn [plant]
            {:plant-entity-id (:plant-uuid plant)
             :layer-type :canopy
             :points (:points plant)}
            #_(namespace-map
               :polyculture
               (select-keys plant [:position :plant])))
          plants)}))

(defn ns-map-js [ns m] (update-keys m (comp keyword (partial str ns "|") name)))

(defn restore-polyculture [polyculture]
  (prn "restore polyculture")

  (remove-polycultures)

  ;; insert polyculture plant data
  (mapv (fn [plant]
          (insert-plant-data (-> plant
                                 (assoc :plant/id (:xt/id plant))
                                 (dissoc :xt/id))))
        (vals (:plants polyculture)))

;; Insert the diagram with out the plants
  (insert-polyculture-data
   (-> polyculture
       (dissoc :plants)
       (dissoc :polyculture/user-id)
       (dissoc :polyculture/plants)))

  (prn "polyculture entity id")
  (prn (fetch-polyculture-entity-id-from-uuid (:xt/id polyculture)))

  (let [poly-entity-id (fetch-polyculture-entity-id-from-uuid (:xt/id polyculture))]
    ;; Insert the plants for this polyculture and link to the plants details
    (mapv
     (fn [plant]
       (insert-polyculture-data
        {:polyculture.plant/points (-> plant :points)
         :polyculture.plant/plant-entity-id (get-plant-entity-id-from-uuid (-> plant :plant-entity-id))
         #_(-> plant :plant-entity-id)
         :polyculture.plant/name (str (get-in polyculture [:plants (-> plant :plant-entity-id keyword) :plant/common-name]))
         :polyculture.plant/polyculture poly-entity-id}))
     (:polyculture/plants polyculture))
    (register-query :polyculture-plants fetch-polyculture-plants [poly-entity-id])
    (register-query :polyculture-plants-stats fetch-polyculture-plants-stats [poly-entity-id])))

(defn fetch-page-polyculture [id]
  (go (let [result (<! (fetch-polyculture id))]
        (if (= true (first result))
          (do
            (restore-polyculture (second result))
            (swap! site-data assoc-in [:page :polyculture] (second result)))
          (swap! site-data assoc-in [:page :polyculture] nil)))))

(defn update-polyculture [id polyculture]
  (prn id)
  (prn polyculture)
  (go (<! (create-new-revision-polyculture id (ns-map-js "polyculture" polyculture)))))

(defn action-update-polyculture [id values]
  (swap! site-data update-in [:page :polyculture]
         merge (-> @site-data :page :polyculture) values)
  #_(prn (merge values (polyculture->fmt-db
                        (-> @site-data :page :polyculture)
                        (-> @site-data :datalog-queries :polyculture-plants))))
  (update-polyculture
   id
   (merge values (polyculture->fmt-db
                  (-> @site-data :page :polyculture)
                  (-> @site-data :datalog-queries :polyculture-plants)))))

(defn init-polycultures-page []
  (prn "init polycultures page")
  (go (swap! app-state assoc-in [:polyculture :list] (second (<! (fetch-polycultures "all"))))))

(defn init-polyculture-page [{:keys [path] :as params}]
  (prn "init polyculture page")
  (fetch-page-polyculture (:id params)))

(defn ui-page-intro []
  [:div.bg-teal-500.rounded-lg.p-4.mb-4
   [:h2.text-2xl.mb-4 "Polyculture creation tool, create a symbiosis of mutualism"]
   [:p.mb-4
    "Do you want to optimize crop yields and improve soil health while promoting biodiversity in your farm or garden? This solution is the one you've been searching for! Our easy-to-use application allows users to effortlessly design and manage polycultures that integrate multiple plant species, creating a diverse ecosystem that supports plant growth diversity and soil health."]
   [:p.mb-4 "With this tool, you can:"]
   [:ul.m-4.list-disc
    [:li "Create customized polyculture designs that reflect your unique growing preferences and goals"]
    [:li "Select from a variety of crops to include in your polyculture, each with their own specific soil, sunlight, and water requirements"]
    [:li "Access expert guidance and recommendations on how to pair plants that complement each other and promote a healthy ecosystem"]
    [:li "Track the growth of your polyculture over time and adapt your design as needed"]
    [:li "Save time and maximize yields by reducing the need for artificial fertilizers and pesticides"]]

   [:p "If you're looking to create a thriving and sustainable polyculture, this tool is the one for you. Sign up today and start growing with confidence!"]
   #_[ui-plant-search (partial plant-search-selection objects)]])

(defn ui-page-polycultures [path]
  (let [list (r/cursor app-state [:polyculture :list])
        values (r/atom {})]
    (fn [path]
      [:div
       (when (empty? @list)
         [:div [ui-page-intro]])

       [:div
        [grid-layout-one
         [:div.m-4 [ui-form-create-polyculture
                    values
                    {:on-submit create-new-polyculture}]]
         (into []
               (mapv (fn [item]
                       [:div.relative
                        [:a.justify-centre.content-center.button
                         {:href (rfe/href :polyculture {:id (:xt/id item)})}
                         [picture
                          {:alt (str "Overview of " (:polyculture/title item))
                           :image (@build-api-url "/api/v2/polyculture/png/" (:xt/id item))}]
                         [:div.absolute.right-0.top-0.bg-tps-primary
                          [button-progress-async
                           "Delete"
                           {:on-click (partial delete-polyculture (:xt/id item))
                            :on-complete (fn [response]
                                           (init-polycultures-page)
                                           #_(change-page {:id (-> response :body :crux :xt/id)}))}]]
                         [:div.p-4
                          [:h6 (str (:polyculture/title item))]
                          [:p (str (:polyculture/description item) #_(item))]]]]) @list))]]])))

#_(defn build-polyculture-sitemap-urls [urls]
    (->> routes
         (reduce (fn handle-sitemap [result [route route-map]]
                   (if (-> route-map :sitemap :vec)
                     (conj result ((-> route-map :sitemap :vec)))
                     (conj result route))) [])
         flatten))

(defn seq-min-max [m [x y]]
  (-> m
      (assoc :x
             {:min (if (< x (or (-> m :x :min) x)) x (or (-> m :x :min) x))
              :max (if (> x (or (-> m :x :max) x)) x (or (-> m :x :max) x))})
      (assoc :y
             {:min (if (< y (or (-> m :y :min) y)) y (or (-> m :y :min) y))
              :max (if (> y (or (-> m :y :max) y)) y (or (-> m :y :max) y))})))

(defn calculate-bounds []
  (reduce seq-min-max {} [[10 20] [11 21] [12 22] [13 22]]))

(defn save-new-revision [id document]
  (create-new-revision-polyculture id document))

(defn map->hiccup [tree]
  (walk/postwalk (fn [x]
                   (print "walked: " (cond
                                       (vector? x) (into [:ul] x)
                                       (set? x) (into [:ul] x)
                                       :else [:li x])  "\n")
                   (cond
                     (vector? x) (into [:ul] x)
                     (set? x) (into [:ul] x)
                     :else [:li x])) tree))

(defn polyculture-keys [key]
  (case key
      ;; "Space" (m/select-plant-modal)
      ;; " " (m/select-plant-modal)
      ;; "d" (toggle-debug)
      ;; "s" (set-mode :select nil)
      ;; "m" (set-mode :move nil)
      ;; "r" (set-mode :remove nil)
      ;; "Escape" (do (reset-mouse) (hide-modal))
    "Delete" (rm-entity (-> @app-state :selected :eid))
      ;; "ArrowUp" (pan-canvas 0 1)
      ;; "ArrowDown" (pan-canvas 0 -1)
      ;; "ArrowLeft" (pan-canvas 1 0)
      ;; "ArrowRight" (pan-canvas -1 0)
    nil))

(defn ui-polyculture-stats-bar []
  (let [plants-stats (r/cursor site-data [:datalog-queries :polyculture-plants-stats])]
    (fn []
      [:div {:class "w-full w-1/2-md"}
       (simple-list
        @plants-stats
        (fn [plant]
          [:<>
               ;[:div (str plant)]
           [:div.flex.items-center.justify-center
            [plant-link (-> plant :plant-entity-id #_:plant/id)]]
           [:div.flex.items-center.justify-center {:on-click #(plant-info-modal (:id plant))}
            (-> plant :name)
            (plant-name (-> @app-state :visual :names) plant #_(:plant plant))]
           [:div.flex.items-center.justify-center.text-sm
            [:span.px-3.py-1.text-blue-200.bg-blue-600.rounded-full
             {:on-click
              (fn [_]
                (insert-plant-mode (-> plant :plant))
                 ;;(add-new-plant (namespace-map :plant (-> plant :plant)))
                 ;;(set-mode :insert (-> plant :plant :plant/type))
                #_(swap! app-state assoc-in [:current :plant]
                         (fetch-plant-eid-from-uuid (-> plant :plant :plant/id)))
                #_(swap! app-state assoc :selected
                         {:eid (-> plant :plants first #_:db/id #_#_:plant :plant/id)
                          :plants [plant]
                          :object (fetch-plant (-> plant :plants first))}))}
             (:count plant)]]]))])))

(defn view-polyculture [])

(defn ui-page-polyculture [{:keys [path] :as params}]
  (let [polyculture (r/cursor site-data [:page :polyculture])
        plants (r/cursor site-data [:datalog-queries :polyculture-plants])
        plants-stats (r/cursor site-data [:datalog-queries :polyculture-plants-stats])
        circles (generate-radius 20 10)
        plant-store (r/atom [])
        polyculture-settings (r/atom false)
        page (r/cursor site-data [:page :polyculture])]
    (fn [{:keys [path] :as params}]
      [:<>
       ;[:div (str (-> @site-data :page))]
       ;[:div "--" (str path)]
       (case @polyculture
         nil [:div "Polyculture not found" (str @polyculture)]
         [:div
          [:div.bg-teal-500.rounded-lg
           #_[ui-plant-search plant-search-selection]
           [ui-plant-search search-selected-plant]]

          (if  (:diagram-owner-requested-access @polyculture)

            [:div.flex.flex-wrap.justify-around
             [:div {:class "w-full w-1/2-md"}
              [:div.relative.container.mb-4.m-auto.cursor-none
               {:class "w-full w-1/2 lg:w-1/2"}
               (when @polyculture-settings
                 [polyculture-settings-form
                  "Polyculture settings"
                  @polyculture
                  #_(select-keys @polyculture [:polyculture/title :polyculture/public])
                  {:submit-fn (fn [values] (prn "submit")
                                (action-update-polyculture (-> path :id) values))
                   :close-fn #(reset! polyculture-settings false)}])

               #_(str (:diagram-owner-requested-access @polyculture))
               (prn (svg-transform {:zoom 0.0 :pos [0.0 0.0] :rotate 0}))
               [svgh/ui-svg-canvas
                "events"
                (partial polyculture-click-event circles)
                polyculture-keys
              ;;(partial add-plant->polyculture circles)
                {:transform (svg-transform {:zoom 0.5 :pos [0.0 0.0]})
                 :view-box "-100 -100 200 200"}
                [:g {:opacity "0.5"}
                 svg/filters
                 (svg/polyculture @plants)
                 [ui-svg-polyculture-preview
                  {:width "400"
                   :height "400"
                   :view-box "0 0 400 400"}
                  circles]]]

               [:div.absolute.flex.flex-row.cursor-pointer.h-8.right-2.top-2
                (when (not-any? #(= % (-> @app-state :mode #_#_:selected :tool)) [:select nil])
                  [:div.w-8.h-8 {:on-click reset-editing} u/icon-close])
                                        ;      [:div.absolute.cursor-pointer.controls {:style {:top "5px" :left "5px"}}
                [:div.w-8.h-8 {:on-click #(reset! polyculture-settings true)} [icon-gears]]

                [svg/zoom
                 :vertical
                 32
                 (fn [e] (.stopPropagation e) (update-zoom :inc))
                 (fn [e] (.stopPropagation e) (update-zoom :dec))]]]]

             [:div [button-progress-async
                    "Save revision"
                    {:on-click
                     (fn []
                       (update-polyculture (-> path :id) (polyculture->fmt-db @polyculture @plants)))}]]

             [ui-plant-info]
             [ui-polyculture-stats-bar]]

            [:div "preview here"
             [svgh/ui-svg-canvas
              "events"
              (partial polyculture-click-event circles)
              polyculture-keys
              ;;(partial add-plant->polyculture circles)
              {:transform (svg-transform)
               :view-box "-100 -100 200 200"}
              [:g {:opacity "0.5"}
               svg/filters
               (svg/polyculture @plants)
               [ui-svg-polyculture-preview
                {:width "400"
                 :height "400"
                 :view-box "0 0 400 400"}
                circles]]]])])])))

(comment
  (fetch-polyculture-plants 37)
  (set-mode :move)
  (set-mode :insert))
